fx.ns("desktop.common.actionbar", class ViewWidget extends fx.components.VBox{

    constructor(data, board, options)
	{
		super(data);

        this._board = board;
        this.options = options;
    }


    create()
	{
		super.create();

        if (!this.options || this.options.preview !== false)
        {
           this.modeSelectionSlider = new fx.components.Box();
            this.previewButton = new fx.components.IconButton({className : "action previewButton", icon : fx.assets.previewIcon});
            
            this.modeSelectionSlider.addChild(this.previewButton, {left:"center", height:40, width:40} );
			this.previewBackground = new fx.components.Box({className : "previewBackground"});
			this.modeSelectionSlider.addChild(this.previewBackground, {top:0, right: 0, height:40, width: 40} );

            this.globalviewButton = new fx.components.IconButton({className : "action", icon : fx.assets.globalView});
            this.globalviewButton.toolTip = fx.text("Vue globale");
            this.globalviewButton.toolTypeStyle = { position : "left", positionMargin : 20 };

            this.zoomButton = new fx.components.IconButton({className : "action", icon : fx.assets.zoomIcon});
            this.zoomButton.toolTip = fx.text("Zoomer");
            this.zoomButton.toolTypeStyle = { position : "left", positionMargin : 20 };

            this.previewBackground.addChild(this.zoomButton, { height:40, width:40, left:5});
            this.previewBackground.addChild(this.globalviewButton, {height:40, width:40, left:35});

            this.addChild(this.modeSelectionSlider, {left:"center", height:40, width:40} );
        }
    }

    onReady()
	{
		super.onReady();

        if (this.globalviewButton)
            this.on("click", this.onGlobalview, this.globalviewButton);

        if (this.zoomButton)
            this.on("click", this.onZoom, this.zoomButton);

        this.on("mouseover", this.onPreviewHover, this.previewBackground);
        this.on("mouseout", this.onPreviewOut, this.previewBackground);
        this.on("mouseover", this.onPreviewHover, this.previewButton);
        this.on("mouseout", this.onPreviewOut, this.previewButton);
    }

    onPreview()
    {
        this.trigger("preview");
    }

    onGlobalview()
    {
        this.trigger("view");

        this.globalviewButton.icon = (this.data.zoom.value == 100) ? fx.assets.globalView : fx.assets.singleView;
        this.globalviewButton.toolTip = (this.data.zoom.value == 100) ? fx.text("Vue globale") : fx.text("Vue page");

        if (this.data.zoom.value == 100)
            this.zoomButton.enable()
        else
            this.zoomButton.disable()
    }

    onPreviewHover(){
		this.previewBackground.width(110);
		this.zoomButton.removeClass("fadeOutLeft");
		this.zoomButton.addClass("fadeInLeft");
		this.globalviewButton.removeClass("fadeOutLeft");
		this.globalviewButton.addClass("fadeInLeft");
	}

	onPreviewOut(){
		this.previewBackground.width(40);
		this.zoomButton.removeClass("fadeInLeft");
		this.zoomButton.addClass("fadeOutLeft");
		this.globalviewButton.removeClass("fadeInLeft");
		this.globalviewButton.addClass("fadeOutLeft");
	}

    onZoom()
    {
        this.trigger("zoom");
    }

    destroy()
    {
        super.destroy();
    }

});